import React from 'react';

const ILMUMalaysia = () => (
  <article className="news-article-body">
    <p className="news-lead">
      On <strong>Malaysia Day, September 16, 2025</strong>, YTL AI Labs made history by launching
      <strong> ILMU</strong> — Malaysia's first homegrown multimodal large language model. Built
      in collaboration with Universiti Malaya, ILMU is fluent in Bahasa Melayu, Manglish, and
      local dialects including Kelantanese, and outperforms GPT-4o on Bahasa Melayu benchmarks.
    </p>

    <h2>What Does ILMU Stand For?</h2>
    <p>
      The name carries dual meaning. In Malay, <em>ilmu</em> means "knowledge" or "learning."
      As an acronym, it stands for <strong>"Intelek Luhur Malaysia Untukmu"</strong> — roughly
      translated as "Malaysia's Elevated Intellect, For You." The deliberate naming signals
      a model built not just in Malaysia, but for Malaysians.
    </p>

    <h2>Performance: Beating Global Frontiers at Home</h2>
    <p>
      ILMU's strength is linguistic depth where global models fall short. On the
      <strong> Malay MMLU</strong> (Massive Multitask Language Understanding) benchmark:
    </p>
    <div className="news-specs-grid">
      <div className="news-spec-item">
        <span className="news-spec-label">ILMU</span>
        <span className="news-spec-value">87.20% accuracy</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">GPT-4o</span>
        <span className="news-spec-value">84.97% accuracy</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">Llama 3.1</span>
        <span className="news-spec-value">78.07% accuracy</span>
      </div>
    </div>
    <p>
      On global English-language benchmarks, ILMU performs comparably to GPT-4o and Llama 3.1
      — demonstrating that sovereign AI capability does not require sacrificing world-class performance.
    </p>

    <h2>Multimodal by Design</h2>
    <p>
      ILMU understands and responds across <strong>text, voice, and images</strong>. This is
      significant: previous Bahasa Melayu models were text-only. ILMU's voice capability is
      specifically trained on Malaysian accents and code-switching patterns
      (the natural mixing of Bahasa Melayu, English, and Mandarin in everyday speech).
    </p>

    <h2>Data Sovereignty — Staying in Malaysia</h2>
    <p>
      A core design principle: all data processed by ILMU remains within Malaysian borders.
      YTL hosts ILMU on its own infrastructure — including a <strong>500MW green data centre
      in Johor</strong> and an AI supercomputer powered by NVIDIA's Grace Blackwell chips.
    </p>
    <p>
      This is a direct response to concerns many Southeast Asian governments have about
      citizen data flowing to US or Chinese hyperscale cloud providers. ILMU establishes
      Malaysia as an example of how mid-sized economies can build genuine AI sovereignty.
    </p>

    <h2>ILMUchat and the Accelerator Programme</h2>
    <p>
      <strong>ILMUchat</strong> — the public-facing AI chatbot — became available on
      Malaysia Day 2025. For businesses and developers, the
      <strong> ILMU Accelerator Programme</strong> offers Malaysian startups and SMEs up to
      <strong>RM 5 million in free API credits</strong>, lowering the barrier for local
      AI-powered product development.
    </p>

    <h2>Significance for the Region</h2>
    <p>
      ILMU's launch positions Malaysia among a small group of countries — alongside
      France (Mistral), China (Qwen, DeepSeek), and South Korea (HyperCLOVA X) — that have
      built frontier-class models rooted in their own language and culture. For ASEAN,
      ILMU signals that the region does not need to rely exclusively on US or Chinese AI
      infrastructure for locally relevant applications.
    </p>

    <div className="news-insight-box">
      <h3>Key Takeaway</h3>
      <p>
        ILMU proves that language-specific frontier AI is achievable outside of Silicon Valley
        and Beijing. As AI becomes embedded in public services, education, and enterprise,
        the ability to process and respond in the native language — with cultural context —
        is not a luxury feature. It is a governance and sovereignty imperative.
      </p>
    </div>
  </article>
);

export default ILMUMalaysia;
